import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { Form } from "react-bootstrap";
import { IStop } from "../Models";

export interface IStopSelectorProps
{
	label?: string|React.ReactElement;
	placeholder?: string;
	stops: IStop[];
	selected?: IStop;
	disabledStop?: IStop;
	disabled?: boolean;
	onStopSelected: (stop: IStop) => void;
}

export const StopSelector = (props: IStopSelectorProps) => {

	const [selected, setSelected] = useState<IStop>(props.selected);

	const stopSelected = (stops: IStop[]) => {
		if (document.activeElement)
			(document.activeElement as HTMLInputElement).blur();
		if (stops.length === 0)
		{
			setSelected(undefined);
			return;
		}

		const stop = stops[0];
		setSelected(stop);
		if (props.onStopSelected)
			props.onStopSelected(stop);
	};

	useEffect(() => {
		setSelected(props.selected);
	}, [props.selected]);

	return <Form.Group className="location-selector">
		<Form.Label>{props.label}</Form.Label>
		<Typeahead
			id="select-stop"
			className="search-box"
			placeholder={props.placeholder}
			labelKey={(stop: IStop) => stop.name}
			options={props.stops || []}
			onChange={stopSelected}
			selected={selected ? [selected] : []}
			highlightOnlyResult
			disabled={props.disabled}
			filterBy={["code","name","short_code","synonyms"]}
			onFocus={() => setSelected(undefined)}
		/>
	</Form.Group>
}